<template>
  <v-col
    :cols="width === 1 ? 6 : 12"
    :class="{
      'max-flex-box-hover': isHighlighted,
    }"
    :style="{ width: computedWidth, height: computedHeight }"
    class="max-flex-box"
  >
    <div v-if="keyConfig" class="max-flex-content">
      <h4>
        Kanal {{ keyConfig.Channel.value + 1 }}:
        {{ MaxFlexButtonFunction[keyConfig.CommandGrp.value].name }}
      </h4>
      <div class="d-flex justify-center align-center">
        <div class="d-flex justify-space-between align-center w-50">
          <div class="max-flex-text">{{ text }}</div>
          <div v-if="nightLED" class="nightLED-column">
            <div :class="{ 'nightLED-active': nightLED }" class="nightLED" />
          </div>
          <div v-if="icon">
            <i :class="`mdi mdi-${icon} mdi-24px`" />
          </div>
        </div>
      </div>
    </div>
  </v-col>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  LocatingKeyButtonMap,
  MaxFlexButtonFunction,
  MaxFlexKeyConfig,
} from '@/apps/brelag/common/models/maxflex/maxflex'

type MaxFlexButtonProps = {
  height: number
  width: number
  isHighlighted?: boolean
  keyNum: number
  config: MaxFlexKeyConfig
}
const props = withDefaults(defineProps<MaxFlexButtonProps>(), {
  isHighlighted: false,
  config: undefined,
})

const keyConfig = computed((): MaxFlexKeyConfig => {
  if (props.config) {
    return props.config.keys[props.keyNum]
  } else {
    return null
  }
})

const icon = computed((): string => {
  if (
    keyConfig.value &&
    keyConfig.value &&
    keyConfig.value.Icon &&
    keyConfig.value.Icon.value
  ) {
    return keyConfig.value.Icon.value
  } else {
    return ''
  }
})

const text = computed((): string => {
  if (
    keyConfig.value &&
    keyConfig.value &&
    keyConfig.value.Text &&
    keyConfig.value.Text.value
  ) {
    return keyConfig.value.Text.value
  } else {
    return ''
  }
})

const nightLED = computed(() => {
  return LocatingKeyButtonMap[props.keyNum] === props.config.LocatingKey.value
})

const computedHeight = computed(() => {
  if (props.height === 1) {
    return '25%'
  } else if (props.height === 2) {
    return '50%'
  } else {
    return '100%'
  }
})

const computedWidth = computed(() => {
  if (props.width === 1) {
    return '50%'
  } else {
    return '100%'
  }
})
</script>

<style lang="scss" scoped>
.max-flex-box {
  box-shadow:
    0 2px 3px rgba(10, 10, 10, 0.4),
    0 0 0 1px rgba(10, 10, 10, 0.4);
  background: white;
}

.max-flex-box:hover {
  background-color: #e6eef3;
}

.max-flex-box-hover {
  background-color: #e6eef3;
}

.max-flex-box .max-flex-content h4 {
  margin-bottom: 5px;
}

.max-flex-content {
  width: 100%;
  text-align: center;
}

.max-flex-text {
  font-size: 14px;
}

.nightLED-column {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nightLED {
  width: 24px;
  height: 24px;
  border: 2px solid #7a7a7a;
  border-radius: 4px;
  opacity: 0.5;
}

.nightLED-active {
  border-color: #1d77b6;
  background: #1d77b6;
  opacity: 1;
}

.max-flex-content .mdi {
  line-height: 1;
}
</style>
